<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-mb-vals-card" v-if="this.valuesList.length != 0">
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      :mobile-breakpoint="0"
      item-key="cd"
      hide-default-footer
      disable-sort
      disable-filtering
      fixed-header
      height="100%"
      dense
      class="tm-mb-detail-stage-values-tbody"
    ></v-data-table>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]ダム 観測値カード
 * TmDamValues.vue
 * @author ILUKE
 */

export default {
  name: "tm-dam-values",
  data() {
    return {
      selectTime: "min",
      rnInc: "累加雨量[mm]"
    };
  },
  created() {
  this.min10List.headers[10].text = this.rnInc;
  this.hourList.headers[10].text = this.rnInc;
  },
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      }
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        if (!this.timeMode) {
          // 10分単位
          return this.min10List.headers;
        }
        // 時間単位
        return this.hourList.headers;
      }
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        if (!this.timeMode) {
          // 10分単位
          return this.min10List.values;
        }
        // 時間単位
        return this.hourList.values;
      }
    },
    /**
     * ダム情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      }
    },
    /**
     * ダム情報(10分) 取得
     */
    min10List: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.min10;
      }
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
</style>